namespace TabAurous.Retail {
    export interface POSReturnRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        PartyId?: number;
        POSCustomerId?: number;
        BaseItemTypeId?: number;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        RoundOff?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: POSReturnItemsRow[];
        TaxDetails?: POSReturnTaxRow[];
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        IsReturned?: boolean;
        ProductItemImage?: string;
        PosCustomerCode?: string;
        CustomerName?: string;
        BirthDate?: string;
        Anniversary?: string;
        TaxId?: string;
        PanNumber?: string;
        Address?: string;
        Mobile?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        CCNetAmount?: number;
        CCTaxAmount?: number;
        CCGrossAmount?: number;
        CCRoundOff?: number;
        Username?: string;
    }

    export namespace POSReturnRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.POSReturn';
        export const deletePermission = 'Retail:POSReturn:Delete';
        export const insertPermission = 'Retail:POSReturn:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSReturn:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            BaseItemTypeId = "BaseItemTypeId",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            RoundOff = "RoundOff",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            TaxDetails = "TaxDetails",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            IsReturned = "IsReturned",
            ProductItemImage = "ProductItemImage",
            PosCustomerCode = "PosCustomerCode",
            CustomerName = "CustomerName",
            BirthDate = "BirthDate",
            Anniversary = "Anniversary",
            TaxId = "TaxId",
            PanNumber = "PanNumber",
            Address = "Address",
            Mobile = "Mobile",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            CCNetAmount = "CCNetAmount",
            CCTaxAmount = "CCTaxAmount",
            CCGrossAmount = "CCGrossAmount",
            CCRoundOff = "CCRoundOff",
            Username = "Username"
        }
    }
}
